import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function Footer() {
  const [f, setF] = useState({});
  const [co, setCo] = useState({});
  const [links, setLinks] = useState([]);
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    api.get("/website/content").then(({ data }) => { setF(data?.footer || {}); setCo(data?.company || data?.footer || {}); });
    api.get("/website/logo").then(({ data }) => setLogo(data)).catch(() => {});
    api.get("/website/pages").then(({ data }) => {
      const visible = (data || [])
        .filter((p) => p.active !== false && p.footer_visible !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      setLinks(visible);
    });
  }, []);
  return (
    <footer className="mt-auto" style={{ backgroundColor: "hsl(var(--footer-bg))", color: "hsl(var(--footer-text))" }} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo dark mediaId={logo?.versions?.footer || logo?.versions?.light} size={logo?.sizes?.footer_width} />
          <p className="mt-4 text-sm text-[hsl(var(--footer-muted))] max-w-sm leading-relaxed">{f.tagline || "Secrétariat médical suisse à distance."}</p>
          <div className="mt-5 space-y-2 text-sm">
            {co.email && <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> {co.email}</div>}
            {co.phone && <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> {co.phone}</div>}
            {co.address && <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-accent" /> {co.address}</div>}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm">
            {links.map((n) => (
              <li key={n.slug}><Link to={n.slug} className="text-[hsl(var(--footer-muted))] hover:text-white transition-colors">{n.menu_title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Espace client</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/connexion" className="text-[hsl(var(--footer-muted))] hover:text-white">Connexion</Link></li>
            <li><Link to="/inscription" className="text-[hsl(var(--footer-muted))] hover:text-white">Créer un compte</Link></li>
            <li><Link to="/demande" className="text-[hsl(var(--footer-muted))] hover:text-white">Faire une demande</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-[hsl(var(--footer-muted))]">
        © {new Date().getFullYear()} Delya — Tous droits réservés. Suisse.
      </div>
    </footer>
  );
}
